import React from 'react';

import { EditGroup } from '../EditGroup';
import { IPropsPrivateGroupSettingsDisplay } from './PrivateGroupSettingsPanel';

export const SettingEditGroup: React.FC<IPropsPrivateGroupSettingsDisplay> = ({
	chat,
	loadingChatChannel,
	loadChatChannel,
	popDisplayState,
}) => {
	return (
		<EditGroup
			chat={chat}
			loadingChatChannel={loadingChatChannel}
			loadChatChannel={loadChatChannel}
			popDisplayState={popDisplayState}
		/>
	);
};
